import React from 'react'
import classNames from 'classnames'

// Thẻ (card) riêng cho TỪNG khối sidebar trang tổ chức - trước đây nhiều khối KHÔNG LIÊN QUAN nhau
// (vd "Thông báo" và "Hội Nhóm") bị gộp chung 1 khung nền/bóng đổ ở OrganizationSider.js, chỉ ngăn
// nhau bằng 1 đường kẻ mảnh (divide-y) - nhìn như 1 khối duy nhất dù nội dung chả liên quan (phản hồi
// thực tế: "sao lại đặt chung vào 1 cục, 2 cái chả liên quan"). Chuyển hẳn khung nền/bo góc/bóng đổ về
// TỪNG khối tự quản (đặt trong chính điều kiện "có dữ liệu mới hiện" của khối đó) thay vì gộp ở
// OrganizationSider.js - vừa tách bạch rõ ràng từng khối, vừa tránh lỗi hiện khung rỗng khi 1 khối
// không có dữ liệu (nếu tách khung ở ngoài mà không đồng bộ điều kiện ẩn/hiện thì dễ lộ khung trống).
export const SiderBlockCard = ({className, children}) => (
    <div
        // style={{boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)'}}
        className={classNames('w-full flex flex-col background shadow-sm rounded-2xl p-3 gap-3', className)}>
        {children}
    </div>
)
